/**
=========================================================
* Material Dashboard 3 PRO React - v2.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 3 PRO React context
import { useMaterialUIController, setLayout } from "context";


function DashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  const isintelligencePage = pathname.startsWith("/intelligence");
  // console.log(pathname, isintelligencePage, "@@@@")
  return (
    <MDBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        p: isintelligencePage ? 0 : '0px 24px 0px 24px',
        pb: isintelligencePage ? 0 : 0,
        position: "relative",
        height: "100vh",          // FIX
        overflow: isintelligencePage ? "hidden" : "hidden", // ✅ kill scroll
        [breakpoints.up("xl")]: {
          // marginLeft: pxToRem(80),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
        marginTop: { xs: "0px", sm: "0px", md: "0px" },
        // background: "pink"
      })}
      className="overall-layout"


    >
      {children}
    </MDBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
